import classNames from "classnames";
import "./loader.scss"; 
import CircleImage from "static/icons/loader-circle.png";

interface loaderProps {
  loading: boolean;
}

const Loader: React.FC<loaderProps> = props => {
  return <div className={classNames("loader", {"is-open": props.loading})}>
    <img src={CircleImage} alt="" />
  </div>
}

export default Loader;
